export const MENTIONS_MENU_MIN_WIDTH = 240;
export const MENTIONS_MENU_MIN_HEIGHT = 320;
export const MENTIONS_MENU_LAYOUT_HEIGHT = 220;
export const MENTIONS_MENU_MIN_USABLE_HEIGHT = 120;
export const MENTIONS_MENU_VIEWPORT_PADDING = 8;
export const MENTIONS_MENU_OFFSET_Y = 4;
export const MENTIONS_MENU_FALLBACK_LINE_HEIGHT = 20;

export type MentionsMenuAnchorPosition = {
  x: number;
  y: number;
  caretTop?: number;
};

export type MentionsMenuFloatingCoords = {
  left: number;
  top: number;
  maxHeight: number;
};

export function getMentionsMenuAnchorRect(position: MentionsMenuAnchorPosition) {
  const padding = MENTIONS_MENU_VIEWPORT_PADDING;
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;

  const minX = padding;
  const maxX = viewportWidth - MENTIONS_MENU_MIN_WIDTH - padding;
  const x = Math.min(Math.max(position.x, minX), maxX);

  const maxY = viewportHeight - padding;
  const minY = padding;
  const y = Math.min(Math.max(position.y, minY), maxY);

  return { x, y };
}

function clampMenuHeight(availableHeight: number) {
  return Math.min(
    MENTIONS_MENU_MIN_HEIGHT,
    Math.max(MENTIONS_MENU_MIN_USABLE_HEIGHT, availableHeight),
  );
}

export function getMentionsMenuFloatingCoords(
  position: MentionsMenuAnchorPosition,
): MentionsMenuFloatingCoords {
  const { x, y: anchorBottom } = getMentionsMenuAnchorRect(position);
  const padding = MENTIONS_MENU_VIEWPORT_PADDING;
  const viewportBottom = window.innerHeight - padding;
  const caretTop =
    position.caretTop ?? anchorBottom - MENTIONS_MENU_FALLBACK_LINE_HEIGHT;

  const belowTop = anchorBottom + MENTIONS_MENU_OFFSET_Y;
  const spaceBelow = viewportBottom - belowTop;

  if (spaceBelow >= MENTIONS_MENU_LAYOUT_HEIGHT) {
    return {
      left: x,
      top: belowTop,
      maxHeight: clampMenuHeight(spaceBelow),
    };
  }

  const availableAbove = caretTop - MENTIONS_MENU_OFFSET_Y - padding;
  const maxHeight = clampMenuHeight(availableAbove);

  return {
    left: x,
    top: Math.max(padding, caretTop - MENTIONS_MENU_OFFSET_Y - maxHeight),
    maxHeight,
  };
}
